export default __webpack_public_path__ + "static/media/Naomi_9781846168918.2723b3f1.jpg";